module.exports = __webpack_public_path__ + "img/bg_function02_2_m.1fd74be3.png";